import { render } from "./NoIdentificationModal.vue?vue&type=template&id=766cef39&ts=true"
import script from "./NoIdentificationModal.vue?vue&type=script&lang=ts"
export * from "./NoIdentificationModal.vue?vue&type=script&lang=ts"

import "./NoIdentificationModal.vue?vue&type=style&index=0&id=766cef39&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__